import {
  useActions,
  useEffect,
  useMemo,
  usePersistedUserData,
  useQueries,
  useQueryParams,
} from 'src/hooks'
import { getPlans } from 'src/legacy_graphql'
import {
  GS_AFFILIATE_ID,
  GS_SALEOR_AFFILIATE_ID,
} from 'src/marketing/plans/constants'
import { useCheckout, useProductVariant } from 'src/react-query/queries/hooks'
import { getPlanDescriptions } from 'src/saleor/utils/getPlanDescriptions'
import useHandleProductActions from './useHandleProductActions'

const matchingPlans = [
  { initial: '15494', reccuring: '14547' },
  { initial: '15495', reccuring: '15394' },
  { initial: '15493', reccuring: '15395' },
  { initial: '15506', reccuring: '13705' },
  { initial: GS_SALEOR_AFFILIATE_ID, reccuring: GS_AFFILIATE_ID },
]

const useAddProductFromQueryParam = () => {
  const queryParams = useQueryParams()
  const actions = useActions()
  const { account } = usePersistedUserData()
  const [plans] = useQueries(getPlans())
  const { data: checkout } = useCheckout()
  const productId = queryParams.promoPlanId
  const isJoiningThroughPackageParam =
    queryParams.isJoiningAffiliate && queryParams.package === 'pro'
  const prePromoPlanStripeId =
    plans.find(plan => plan.id === productId)?.stripeId ?? ''

  const hasProductAlready = useMemo(
    () => productId && account?.plan.id === productId,
    [account, productId],
  )

  const refinedPromoPlanStripeId = isJoiningThroughPackageParam
    ? GS_SALEOR_AFFILIATE_ID
    : matchingPlans.find(p => p.reccuring === prePromoPlanStripeId)?.initial ??
      prePromoPlanStripeId

  const productActions = useHandleProductActions(refinedPromoPlanStripeId)
  const plan = useMemo(() => plans.find(p => p.id === productId), [
    plans,
    productId,
  ])
  const planDescriptions = getPlanDescriptions(plans)
  const variantIdOnPlan = plan
    ? planDescriptions[plan?.id]?.saleorVariantId
    : ''
  const { data } = useProductVariant(
    { sku: plan?.stripeId ?? refinedPromoPlanStripeId },
    !!!variantIdOnPlan,
  )
  const variantId = !!variantIdOnPlan ? variantIdOnPlan : data?.id
  const isMutatingCheckout =
    productActions.isCreatingCheckout || productActions.isUpdatingCheckout
  const isInCart = productActions.checkIsInCart(checkout)

  useEffect(() => {
    if (
      refinedPromoPlanStripeId !== '' &&
      variantId &&
      !isInCart &&
      !isMutatingCheckout &&
      !hasProductAlready
    ) {
      productActions.addToCart(variantId)
      actions.checkoutOpenState(true)
      queryParams.removeQueryParams()
    }
  }, [
    refinedPromoPlanStripeId,
    actions,
    queryParams,
    productActions,
    isMutatingCheckout,
    isInCart,
    variantId,
    hasProductAlready,
  ])

  return {
    productActions,
  }
}

export default useAddProductFromQueryParam
